import {createSlice} from '@reduxjs/toolkit'

const initialState = {
    open: false,
    title: 'Warning',
    text: 'Are you sure?',
    agreeText: 'Yes',
    disagreeText: 'No',
    action: () => {
    }
}


export const alertSlice = createSlice({
    name: 'alerts',
    initialState,
    reducers: {
        alertAction: (state, action) => {
            state.open = action.payload.open !== undefined ? action.payload.open : initialState.open;
            state.title = action.payload.title !== undefined ? action.payload.title : initialState.title;
            state.text = action.payload.text !== undefined ? action.payload.text : initialState.text;
            state.agreeText = action.payload.agreeText !== undefined ? action.payload.agreeText : initialState.agreeText;
            state.disagreeText = action.payload.disagreeText !== undefined ? action.payload.disagreeText : initialState.disagreeText;
            state.action = action.payload.action !== undefined ? action.payload.action : initialState.action;
        },
    },
})

export const {alertAction} = alertSlice.actions

export default alertSlice.reducer
